var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPurpleStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 116,
    height: 116,
    viewBox: "0 0 116 116",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M103.366 88.9946C74.3321 88.9946 47.1988 100.549 37.2615 106.326C29.2678 110.287 26.1539 104.675 25.5962 101.374C25.5962 73.6441 13.4984 47.73 7.44949 38.2392C4.33867 32.2971 8.74567 28.3357 11.338 27.0978C46.594 25.1171 70.0979 13.8932 77.4429 8.52884C86.7753 5.5578 89.9726 11.4174 90.4046 14.7185C91.4416 41.4579 103.798 68.775 109.847 79.0911C112.958 86.0235 106.823 88.5819 103.366 88.9946Z",
    stroke: "#7742FE",
    strokeOpacity: 0.08,
    strokeWidth: 6.95476
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M64.5323 109.643C45.9716 89.5595 20.2583 78.525 9.72174 75.5181C1.74257 72.6404 3.81648 66.7302 5.85083 64.1348C25.9339 45.5741 36.9683 19.8607 39.9751 9.32404C42.29 3.195 47.9762 3.5918 50.53 4.55633C74.5024 27.6172 97.6566 36.3623 106.237 37.8522C114.355 42.3189 112.155 48.4524 110.04 50.9609C91.3373 69.5759 79.4524 96.4076 75.8478 107.497C72.8157 114.289 67.0408 111.757 64.5323 109.643Z",
    stroke: "#7742FE",
    strokeOpacity: 0.08,
    strokeWidth: 6.95476
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPurpleStar);
export default __webpack_public_path__ + "static/media/purpleStar.fac843a37318d681a7b74c90c632d702.svg";
export { ForwardRef as ReactComponent };